import settings from "../../../../../backend/src/Case.BMAW.RestAPI/whitelabel.settings.json";
import { getTypedKeys } from "./functions/get-typed-keys.function";

export const appSettingsKeys = getTypedKeys(settings);
